import React, { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Outlet, useLocation } from "react-router-dom";
import PageLoader from "./PageLoader";

const FontLayout = () => {
    const [loading, setLoading] = useState(false);
    const location = useLocation();

    const isLoginPage = location.pathname === "/login";

    return (
        <>
            <style>
                {`
                body{ 
                  margin:0; 
                  padding:0;
                }

                .header-container{ 
                   position: fixed; 
                   top:0; 
                   left:0; 
                   right:0; 
                   z-index:1050;
                }

                .page-wrapper{ 
                    padding-top: ${isLoginPage ? "0px" : "88px"};
                }

                .content-wrapper{
                    margin:0;
                    padding:0;
                }

                section{
                    margin:0;
                }
                `}
            </style>

            <div className="page-wrapper">

                {!isLoginPage && (
                    <div className="header-container">
                        <Header />
                    </div>
                )}

                {/* CONTENT */}
                <div className="content-wrapper">
                    <div style={{ position: "relative" }}>
                        {loading && <PageLoader />}
                        <Outlet context={{ setLoading }} />
                    </div>
                </div>

                {!isLoginPage && <Footer />}

            </div>
        </>
    );
};

export default FontLayout;